module.exports = __webpack_public_path__ + "img/no-search-projects.c21c098d.svg";